// extracted by mini-css-extract-plugin
export var employeePosition = "QuoteWithPhoto-module--employee-position--add5a";
export var flipped = "QuoteWithPhoto-module--flipped--e47f8";
export var image = "QuoteWithPhoto-module--image--4953c";
export var photoOnLeft = "QuoteWithPhoto-module--photo-on-left--d9124";
export var quote = "QuoteWithPhoto-module--quote--0b9e0";
export var quoteWithPhotoContainer = "QuoteWithPhoto-module--quote-with-photo-container--6ea20";
export var textContainer = "QuoteWithPhoto-module--text-container--d680f";
export var wrapper = "QuoteWithPhoto-module--wrapper--76ca5";